export const app_category_options = [{
        value: "usability",
        label: "Ease of use"
    },
    {
        value: "performance",
        label: "Performance"
    },
    {
        value: "bugs",
        label: "Bugs & reliability"
    },
    {
        value: "features",
        label: "Features"
    },
    {
        value: "design",
        label: "Design & appearance"
    },
    {
        value: "other",
        label: "Other"
    },
];

export const match_category_options = [
    {
        value: "organization",
        label: 'Match organization'
    },
    {
        value: "level_balance",
        label: 'Match level balance'
    },
    {
        value: "court",
        label: 'Court (location/status)'
    },
    {
        value: "players",
        label: 'Player experience'
    },
    // {
    //     value: "host",
    //     label: 'Organization'
    // },
    {
        value: "overall_experience",
        label: 'Experience over all'
    },
    {
        value: "other",
        label: 'Other'
    },


];